/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbMobileRefineMenuFilterDimensions_user$ref = any;
type SbMobileRefineMenuFilterPrice_user$ref = any;
type SbRespRefineMenuFilterDimensions_user$ref = any;
type SbRespRefineMenuFilterPrice_user$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_user$ref = any;
export type SbSharedRefineMenuFilters_user$ref = any;
export type SbSharedRefineMenuFilters_user = {
    readonly " $fragmentRefs": SbRespRefineMenuFilterPrice_user$ref & SbRespRefineMenuFilterDimensions_user$ref & SbMobileRefineMenuFilterPrice_user$ref & SbMobileRefineMenuFilterDimensions_user$ref & TradeOnboardingCoachmarkConditionalLoader_user$ref;
    readonly " $refType": SbSharedRefineMenuFilters_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_user",
      "args": null
    }
  ]
};
(node as any).hash = '6342fa9454da3e7b7a876ada995037a4';
export default node;
